import React, { useState, useEffect } from "react";
import DateTimeUtils from "utils/DateTimeUtils";
import { useSelector, useDispatch } from "react-redux";
import { configureKey } from "redux/reducers/shifts";
import useAsyncCallback from "hooks/useAsyncCallback";
import {
  fetchShifts,
  postShiftMessage,
  approveShift,
} from "redux/actions/shifts";
import { Divider } from "@material-ui/core";
import BackdropSpinner from "components/BackdropSpinner";
import toastActions, { ToastType } from "redux/actions/toast";
import {
  ShiftContent,
  DateChanger,
  Container,
  DateTimeContainer,
} from "./components";
import { fetchCompany } from "redux/actions/company";

const ShiftConfirm = () => {
  const dispatch = useDispatch();
  const driver = useSelector((state) => state.account.driver);
  const company = useSelector((state) => state.company);
  const [currentDate, setCurrentDate] = useState(DateTimeUtils.local());
  const [month, setMonth] = useState(currentDate.toFormat("yyyy-MM"));
  const [message, setMessage] = useState("");

  const shift = useSelector(
    (state) => state.shifts[configureKey(currentDate.toJSDate(), company)]
  );
  const companyTel = company.tel;

  useEffect(() => {
    dispatch(fetchCompany({ companyId: driver.companyId }));
  }, [driver.companyId]);

  const {
    refresh: refreshShifts,
    isLoading: isFetchingShifts,
  } = useAsyncCallback(
    () =>
      dispatch(
        fetchShifts({
          companyId: driver.companyId,
          driverId: driver.driverId,
          month,
        })
      ),
    [month]
  );

  const {
    refresh: postMessage,
    isLoading: isPostingMessage,
  } = useAsyncCallback(
    () =>
      dispatch(
        postShiftMessage({
          companyId: driver.companyId,
          req: {
            driverShiftId: shift.driverShiftId,
            driverMemo: message,
          },
        })
      ),
    [message, shift]
  );

  const {
    refresh: postApproveShift,
    isLoading: isApprovingShift,
  } = useAsyncCallback(
    () =>
      dispatch(
        approveShift({
          companyId: driver.companyId,
          driverShiftId: shift.driverShiftId,
        })
      ),
    [message, shift]
  );

  const onApproveShift = async () => {
    const res = await postApproveShift();
    if (!res.error) {
      dispatch(
        toastActions.showToast({
          text: "送信に成功しました！",
          type: ToastType.Success,
        })
      );
    }
  };

  const onChangeMessage = (e: any) => {
    setMessage(e.target.value);
  };

  const onClickSendMessage = async () => {
    const res = await postMessage();
    if (!res.error) {
      dispatch(
        toastActions.showToast({
          text: "送信に成功しました！",
          type: ToastType.Success,
        })
      );
    }
  };

  const onClickNextDay = () => {
    setCurrentDate((prev) => prev.plus({ day: 1 }));
  };

  const onClickPreviousDay = () => {
    setCurrentDate((prev) => prev.minus({ day: 1 }));
  };

  useEffect(() => {
    refreshShifts();
  }, [refreshShifts]);

  useEffect(() => {
    setMonth(currentDate.toFormat("yyyy-MM"));
  }, [currentDate]);

  useEffect(() => {
    setMessage(shift?.driverMemo || "");
  }, [shift]);

  return (
    <>
      <Container>
        <DateTimeContainer>
          {currentDate.toFormat("yyyy'/'MM'/'dd (EEEE)")}
        </DateTimeContainer>
        <Divider flexItem style={{ height: 1 }} variant="middle" />
        <ShiftContent
          shift={shift}
          message={message}
          onApproveShift={onApproveShift}
          companyTel={companyTel}
          onChangeMessage={onChangeMessage}
          onClickSendMessage={onClickSendMessage}
        />
        <DateChanger
          onClickPreviousDay={onClickPreviousDay}
          onClickNextDay={onClickNextDay}
        />
      </Container>
      <BackdropSpinner
        isLoading={isFetchingShifts || isApprovingShift || isPostingMessage}
      />
    </>
  );
};

export default ShiftConfirm;
